var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainBox",attrs:{"id":"courseTable"}},[_c('Table',{attrs:{"size":"large","columns":_vm.courseColumns,"data":_vm.courseData,"stripe":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }